if (document.getElementById("giftogramTrigger")) {
    import("../Components/Vanilla/GiftogramTrigger");
}